import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { combineLatest, Observable, Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { DickerSelectListItem, TenantResponse } from '../../../models/check-out.model';
import { PostcodeList, SuburbList } from '../../../models/account-delivery-address';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { ManageService } from '../../../services/manage.service';
import { CommonService } from '../../../services';
import { CompanyInfoViewModel, CurrentUserModel, StateModel } from '../../../models/account-ledger.model';
import { ManageByProgram, SubscriptionPrograms } from '../../../models/imanage.model';
import { AuthService } from '../../../services/auth.service';
import { MyAccountService } from '../../../services/myAccount.service';

@Component({
  selector: 'app-create-watchguard-contract',
  templateUrl: './create-watchguard-contract.component.html',
  styleUrls: ['./create-watchguard-contract.component.css']
})
export class CreateWatcGuardContractComponent implements OnInit, OnDestroy {

  title: string = "New WatchGuard Contract";
  public companyInfo: CompanyInfoViewModel;
  activePrograms: ManageByProgram[];
  dicoverPrograms: ManageByProgram[];
  resellerId:string;
  setFullWindow: boolean = true;
  userFormGroup: FormGroup;
  stateList: string[];
  provisionTypeList = [
    "AuthPoint Security", "EndPoint Security"
  ]
  loadContent: boolean = false;
  tenantId: string = '';
  selectedPayment: string = '';
  paymentList: DickerSelectListItem[] = [];
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  user_validation_messages: any = {
    "provisionTypeField": [
      { class: "provisionTypeValidate", message: "Please select security type" }
    ],
    "firstNameField": [
      { class: "firstNameValidate", message: "Please enter first name" }
    ],
    "lastNameField": [
      { class: "lastNameValidate", message: "Please enter last name" }
    ],
    "emailField": [
      { class: "emailValidate", message: "Please enter email" }
    ],
    "companyNameField": [
      { class: "companyNameValidate", message: "Please enter company name" }
    ],
    // "companyDescField": [
    //   { class: "companyDescValidate", message: "Please enter company description" }
    // ],
    "addressLine1Field": [
      { class: "addressLine1Validate", message: "Please enter address" }
    ],
    "suburbField": [
      { class: "suburbValidate", message: "Please enter suburb" }
    ],
    "stateField": [
      { class: "stateValidate", message: "Please choose state" }
    ],
    "postcodeField": [
      { class: "postcodeValidate", message: "Please enter postcode" }
    ],
    "phoneField": [
      { class: "phoneValidate", message: "Please enter phone" }
    ],
  };

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  public user$: Observable<CurrentUserModel>;

  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private manageService: ManageService,
    private myAccountService: MyAccountService,
    private commonService: CommonService,
    private authService: AuthService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getUserGroup()
    });
  }

  ngOnInit() {
    this.user$ = this.authService.getLoginInfo();
    combineLatest([
      this.myAccountService.getCompanyProfile(),
      this.shoppingCartService.getState(),
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        ([company, statesRes]) => {
          this.stateList = statesRes.states;
          this.companyInfo = company;

          // this.userFormGroup.get('userGroup.firstNameField').setValue(this.currentUser.firstName)
          // this.userFormGroup.get('userGroup.lastNameField').setValue(this.currentUser.lastName)
          // this.userFormGroup.get('userGroup.emailField').setValue(this.currentUser.email)
          // this.userFormGroup.get('userGroup.phoneField').setValue(this.currentUser.mobileNumber)

          this.userFormGroup.get('userGroup.companyNameField').setValue(this.companyInfo?.companyName)
          this.userFormGroup.get('userGroup.addressLine1Field').setValue(this.companyInfo?.addressLine)
          this.userFormGroup.get('userGroup.addressLine2Field').setValue(this.companyInfo?.addressLine2)
          this.userFormGroup.get('userGroup.suburbField').setValue(this.companyInfo?.suburb)
          this.userFormGroup.get('userGroup.stateField').setValue(this.companyInfo?.state)
          this.userFormGroup.get('userGroup.postcodeField').setValue(this.companyInfo?.postcode)
        },
        (err) => console.error(err)
      );


    this.getResellerId();
  }

  private getResellerId() {
    this.loadContent = true;
    this.manageService.getSubscriptionPrograms()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (value: SubscriptionPrograms) => {
          this.activePrograms = value.activePrograms;     
          this.dicoverPrograms = value.discoverPrograms;   
          const wgsActive = this.activePrograms.find(p => p.programType == "WGS");
          const wgsDiscover = this.dicoverPrograms.find(p => p.programType == "WGS");
          if (wgsActive) this.resellerId = wgsActive.resellerId;  
          if (wgsDiscover) this.resellerId = wgsDiscover.resellerId;
        },
        (error: any) => {
          console.log(error);
        },
        () => {
          this.loadContent = false;
        }
      );
  }

  getUserGroup(): FormGroup {
    return this.formBuilder.group({
      programType: 'WGS',
      // provisionTypeField: new FormControl("", Validators.compose([Validators.required])),
      firstNameField: new FormControl("", Validators.compose([Validators.required])),
      lastNameField: new FormControl("", Validators.compose([Validators.required])),
      emailField: new FormControl("", this.commonService.emailValidatorRegex()),
      userNameField: new FormControl({ value: "admin", disabled: true }, Validators.required),
      companyNameField: new FormControl("", Validators.compose([Validators.required])),
      // companyDescField: new FormControl("", Validators.compose([Validators.required])),
      addressLine1Field: new FormControl("", Validators.compose([Validators.required])),
      addressLine2Field: new FormControl(""),
      addressLine3Field: new FormControl(""),
      suburbField: new FormControl("", Validators.compose([Validators.required])),
      stateField: new FormControl("", Validators.compose([Validators.required])),
      postcodeField: new FormControl("", Validators.compose([Validators.required])),
      phoneField: new FormControl("", Validators.compose([Validators.required]))
    });
  }

  saveEndUser(): void {
    
    if (this.userFormGroup.get("userGroup").valid) {
      let flag = false;
      if (this.userFormGroup.get('userGroup.postcodeField').value.length < 4) {
        flag = true;
        this.commonService.showValidator('.postcodeValidate', "Please input valid postcode", "right", "error");
      }
      if (!flag) {
        this.loadContent = true;
        let inputModel = {} as any;
        inputModel = {
          programType: 'WGS',
          // provisionTypeField: encodeURIComponent(this.userFormGroup.get('userGroup.provisionTypeField').value.replace(' Security','')),
          firstNameField: encodeURIComponent(this.userFormGroup.get('userGroup.firstNameField').value),
          lastNameField: encodeURIComponent(this.userFormGroup.get('userGroup.lastNameField').value),
          emailField: encodeURIComponent(this.userFormGroup.get('userGroup.emailField').value),
          userNameField: this.userFormGroup.get('userGroup.userNameField').value,
          companyNameField: encodeURIComponent(this.userFormGroup.get('userGroup.companyNameField').value),
          // companyDescField: encodeURIComponent(this.userFormGroup.get('userGroup.companyDescField').value),
          addressLine1Field: encodeURIComponent(this.userFormGroup.get('userGroup.addressLine1Field').value),
          addressLine2Field: this.userFormGroup.get('userGroup.addressLine2Field').value,
          addressLine3Field: this.userFormGroup.get('userGroup.addressLine3Field').value,
          suburbField: this.userFormGroup.get('userGroup.suburbField').value,
          stateField: this.userFormGroup.get('userGroup.stateField').value,
          postcodeField: this.userFormGroup.get('userGroup.postcodeField').value,
          phoneField: this.userFormGroup.get('userGroup.phoneField').value
        };
        this.manageService.createWGSTenant(JSON.stringify(inputModel)).subscribe((res: TenantResponse) => {
          this.loadContent = false;
          if (res.result == "Success") {
            this.tenantId = res.tenantId;
            this.manageService.monitorAnnuity(res);
            this.commonService.implementToast(res.info, "Success");
            setTimeout(() => {
              this.manageService.getOrRefreshProgramsSubject.next();
              this.router.navigateByUrl('/manageSubscriptions');
            }, 1000);
          } else {
            this.commonService.implementToast(res.info, "Error");
          }
        },
          (error: any) => {
            console.error(error);
            this.commonService.implementToast(error.responseMessage, "Error");
            this.loadContent = false;
          });
      }
    } else {
      // this.isNotValidField("userGroup.provisionTypeField", this.user_validation_messages.provisionTypeField);
      this.isNotValidField("userGroup.firstNameField", this.user_validation_messages.firstNameField);
      this.isNotValidField("userGroup.lastNameField", this.user_validation_messages.lastNameField);
      this.isNotValidField("userGroup.emailField", this.user_validation_messages.emailField);
      this.isNotValidField("userGroup.companyNameField", this.user_validation_messages.companyNameField);
      // this.isNotValidField("userGroup.companyDescField", this.user_validation_messages.companyDescField);
      this.isNotValidField("userGroup.addressLine1Field", this.user_validation_messages.addressLine1Field);
      this.isNotValidField("userGroup.suburbField", this.user_validation_messages.suburbField);
      this.isNotValidField("userGroup.stateField", this.user_validation_messages.stateField);
      this.isNotValidField("userGroup.postcodeField", this.user_validation_messages.postcodeField);
      this.isNotValidField("userGroup.phoneField", this.user_validation_messages.phoneField);
    }
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('userGroup.postcodeField').setValue(option.postcode);
    this.userFormGroup.get('userGroup.stateField').setValue(option.state);
    this.userFormGroup.get('userGroup.suburbField').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  startFilterPostcode(res: PostcodeList[]): void {
    this.filteredPostCode = res;
  }
  startFilterSub(res: PostcodeList[]): void {
    this.filteredSub = res;
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  isNotValidField(path: string, validation: any): void {
    if (path == "userGroup.emailField") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  onInputSub(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  close() {
    this.manageService.getOrRefreshProgramsSubject.next();
    this.router.navigateByUrl('/manageSubscriptions');
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
